import { useState } from "react";
import { sendSMS } from "../../../../../../APIs/Messages/SendSMS";
import { useBookingPermissions } from "../../../../../../hooks/useBookingPermissions";
import { useDiaryContext } from "../../../../../../hooks/useDiaryContext";
import { getCustomerName } from "../../../../../../utils/booking";
import Loading from "../../../../../../utils/Loading";
import { EDSButton } from "../../../../../eds/EDSButton";
import DetachedModal from "../../../../../Shared/Modals/DetachedModal/DetachedModal";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "../../../../../ui/select";

type SendSmsType = {
  handleClose: () => void;
  handleSent: () => void;
};

const SendSms = ({ handleClose, handleSent }: SendSmsType) => {
  const [message, setMessage] = useState<string>("");
  const [sending, setSending] = useState<boolean>(false);

  const { selectedBooking, selectedBookingV4, venueConfig } = useDiaryContext();
  const { userCanCreateMessages } = useBookingPermissions();

  const preDefinedMessages =
    venueConfig?.sms_messages?.filter(
      (m) => m.contents !== "" && m.name !== ""
    ) ?? [];

  return (
    <DetachedModal heading="Send SMS" width="80%" handleClose={handleClose}>
      <div className="SendSmsModalDetails flex flex-col flex-1 pt-4 gap-4">
        <div className="SendSmsModal-Recipient pb-4 flex justify-between">
          <div>
            {`To: ${
              selectedBookingV4?.phone ??
              (selectedBooking ? getCustomerName(selectedBooking) : "") ??
              ""
            }`}
          </div>
        </div>
        {preDefinedMessages.length > 0 && (
          <div className="SendSmsModal-Predefined flex items-center gap-2 flex-wrap">
            {"Predefined messages: "}
            <Select
              value=""
              onValueChange={(value) => {
                setMessage(value);
              }}
            >
              <SelectTrigger className="w-full sm:w-[200px]">
                <SelectValue placeholder="Select message" />
              </SelectTrigger>
              <SelectContent>
                {preDefinedMessages.map((msg) => (
                  <SelectItem key={msg.id} value={msg.contents}>
                    {msg.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        )}
        <div className="SendSmsModal-MessageContainer pt-8 flex-1 flex flex-col">
          <label
            htmlFor="sms-message"
            className="SendSmsModal-MessageHeader flex justify-between items-center"
          >
            Message:
          </label>
          <div className="SendSmsModal-Message">
            <textarea
              id="sms-message"
              className="w-full resize-none text-base border-2 border-[var(--FooterGridBackground)] bg-transparent p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-primary placeholder:text-[var(--searchPlaceholder)] placeholder:opacity-100"
              disabled={sending}
              value={message}
              rows={5}
              onChange={(e) => {
                setMessage(e.target.value);
              }}
            />
          </div>
        </div>
        <div className="SendSmsModal-SendButton flex justify-end pt-4">
          {sending ? (
            <Loading />
          ) : (
            <EDSButton
              type="submit"
              disabled={sending || !userCanCreateMessages}
              onClick={async () => {
                if (!selectedBooking?.id || message === "") {
                  return;
                }
                setSending(true);
                await sendSMS(selectedBooking.id, message);
                handleSent();
              }}
            >
              Send SMS
            </EDSButton>
          )}
        </div>
      </div>
    </DetachedModal>
  );
};

export default SendSms;
